function getGenderNormalized(gender) {
    if (!gender)
        return '';
    var genderValues = {
        M: 'M',
        MALE: 'M',
        F: 'F',
        FEMALE: 'F',
        O: 'O',
        OTHER: 'O'
    };
    var value = gender.toUpperCase();
    return genderValues[value] || '';
}
export default getGenderNormalized;
//# sourceMappingURL=getGenderNormalized.js.map